export default __webpack_public_path__ + "static/media/image-34.1cc5042d.png";